import {
  useBooking,
  useBookingForm,
} from "../../../hooks/reservation/useBookingsForm";
import { submitBookingsData } from "../../../hooks/submission/useSubmission";
import { API_BOOKINGS_PAGINATED } from "../../../utils/apis";
import {
  ADVANCE_BOOKING,
  ADVANCE_BOOKINGS,
  ALL_BOOKING,
  ALL_BOOKINGS,
  APPROVED_BOOKING,
  APPROVED_BOOKINGS,
  REJECTED_BOOKING,
  REJECTED_BOOKINGS,
  RESERVED_BOOKING,
  RESERVED_BOOKINGS,
  STICKER_BOOKING,
  STICKER_BOOKINS,
  SUBMITTED_BOOKING,
  SUBMITTED_BOOKINGS,
} from "../../../utils/constants";

export const bookingsRegisterRoutes = {
  bookings: useBooking,
};

export const bookingsFormRoutes = {
  bookings: useBookingForm,
};

export const bookingsFormSubmit = {
  bookings: submitBookingsData,
};

export const bookingsApis = {
  bookings: API_BOOKINGS_PAGINATED,
};

export function getBookingsDataApi(type: any) {
  const typeMapping = {
    [RESERVED_BOOKING]: API_BOOKINGS_PAGINATED,
    [RESERVED_BOOKINGS]: API_BOOKINGS_PAGINATED,

    [ADVANCE_BOOKING]: API_BOOKINGS_PAGINATED,
    [ADVANCE_BOOKINGS]: API_BOOKINGS_PAGINATED,

    [STICKER_BOOKING]: API_BOOKINGS_PAGINATED,
    [STICKER_BOOKINS]: API_BOOKINGS_PAGINATED,

    [APPROVED_BOOKING]: API_BOOKINGS_PAGINATED,
    [APPROVED_BOOKINGS]: API_BOOKINGS_PAGINATED,

    [REJECTED_BOOKING]: API_BOOKINGS_PAGINATED,
    [REJECTED_BOOKINGS]: API_BOOKINGS_PAGINATED,

    [SUBMITTED_BOOKING]: API_BOOKINGS_PAGINATED,
    [SUBMITTED_BOOKINGS]: API_BOOKINGS_PAGINATED,

    [ALL_BOOKING]: API_BOOKINGS_PAGINATED,
    [ALL_BOOKINGS]: API_BOOKINGS_PAGINATED,
  };

  return typeMapping[type];
}
